// extracted by mini-css-extract-plugin
export var editButton = "_pa-0";